export default "__VITE_ASSET__Cm$TFUro__"